import { Container, Stack } from "@mui/material";
import { Page } from "../../../../components";
import HeaderBreadcrumbs from "../../../../components/header-breadcrumbs";
import { RecipientsComponentV2 } from "../../../../components/message-center/v2/recipients-v2/recipients-component-v2";

export const EditAutomatedReminderRecipientsScreen = () => {
    return (
        <Page title="POM Safe - Edit Recipients">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Edit automated reminder"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Edit Recipients', href: window.location.pathname },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <RecipientsComponentV2 mode="reminder" />
            </Container>
        </Page>
    )
}